import React, { useContext, useCallback, useEffect } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from '../../../SpaAndWellCommonStyles.module.scss';
import metadata from './Teaching.metadata.json5';
import InstructorInfo from '../InstructorInfo/InstructorInfo';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function Teaching(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('Teaching');
    const modelVM = _.get(submissionVM, pathUpdated);

    modelVM.value.isValidationReq = true;

    const initializeTeachingFields = () => {
        const doetheappteaPlaPenpubFieValue = _.get(modelVM, 'doetheappteaPlaPenpubFie.value') !== undefined
            ? _.get(modelVM, 'doetheappteaPlaPenpubFie.value') : false;
        const arethestusupatalltpubFieValue = _.get(modelVM, 'arethestusupatalltpubFie.value') !== undefined
            ? _.get(modelVM, 'arethestusupatalltpubFie.value') : false;
        const doetheappteaPlaRicpubFieValue = _.get(modelVM, 'doetheappteaPlaRicpubFie.value') !== undefined
            ? _.get(modelVM, 'doetheappteaPlaRicpubFie.value') : false;
        const dostuoffLassertothpubFieValue = _.get(modelVM, 'dostuoffLassertothpubFie.value') !== undefined
            ? _.get(modelVM, 'dostuoffLassertothpubFie.value') : false;
        const doallclisigawaiholharFieValue = _.get(modelVM, 'doallclisigawaiholharFie.value') !== undefined
            ? _.get(modelVM, 'doallclisigawaiholharFie.value') : true;
        const dostuoffMicsertothpubFieValue = _.get(modelVM, 'dostuoffMicsertothpubFie.value') !== undefined
            ? _.get(modelVM, 'dostuoffMicsertothpubFie.value') : false;
        const thenumofhoucompritpubFieValue = _.get(modelVM, 'thenumofhoucompritpubFie.value') !== undefined
            ? _.get(modelVM, 'thenumofhoucompritpubFie.value') : 0;
            

        _.set(modelVM, 'doetheappteaPlaPenpubFie.value', doetheappteaPlaPenpubFieValue);
        _.set(modelVM, 'arethestusupatalltpubFie.value', arethestusupatalltpubFieValue);
        _.set(modelVM, 'doetheappteaPlaRicpubFie.value', doetheappteaPlaRicpubFieValue);
        _.set(modelVM, 'dostuoffLassertothpubFie.value', dostuoffLassertothpubFieValue);
        _.set(modelVM, 'doallclisigawaiholharFie.value', doallclisigawaiholharFieValue);
        _.set(modelVM, 'dostuoffMicsertothpubFie.value', dostuoffMicsertothpubFieValue);
        _.set(modelVM, 'thenumofhoucompritpubFie.value', thenumofhoucompritpubFieValue);
    }

    useEffect(() => {
        initializeTeachingFields()
    }, [])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        instructorInfoComponent: {
            data: modelVM.instInfExposures,
            updateWizardData,
            submissionVM,
            instructorInfoPath: `${pathUpdated}.instInfExposures`
        },
        studentOfferserviceContainer:{
            visible:_.get(modelVM,'dostuoffsertothepupubFie.value',false)
        },
        dostuoffBodInjsertpubFie: {
            defaultValue: false
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            instructorInfoComponent: InstructorInfo
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            const  EstAnnualGrossReceipts = ["pubSerbyStuFie","pubSerbyNonStuFie","tuiFeeFie","othGroRecFie"]

             if(EstAnnualGrossReceipts.includes(changedPath)){

                const totalGross = EstAnnualGrossReceipts.reduce((sum ,item)=> sum + +(_.get(modelVM.value,item,0)),0);
               
                _.set(submissionVM, `${pathUpdated}.totYeaTeaRecGroSalRecFie`, totalGross);
            }

            updateWizardData(submissionVM);
        },
        [modelVM, pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

Teaching.propTypes = wizardProps;
export default withRouter(Teaching);
